module.exports = {
	"zh-CN": [
		{
			"name": "基础组件",
			"groups": [
				{
					"groupName": "Basic",
					"list": [
						{
							"path": "/sample",
							"title": "Sample组件"
						},
						{
							"path": "/button",
							"title": "Button组件"
						},
						{
							"path": "/switch",
							"title": "Switch组件"
						}
					]
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./docs/nav.config.json
// module id = 29
// module chunks = 1